<div class="error__page-container">
  <div class="error__message">
    <p>No resources found with the Site Path: {{ sitePath }}.</p>
    <p>Update Django to use the correct path.</p>
    <p>The correct path for the client can be found here: src\assets\assets-branded</p>
  </div>
</div>
